module.exports = __webpack_public_path__ + "static/media/fm-icons-Down_arrow.3a1270af.svg";